(ns ycweb.app.website.header.header
  (:require
   [ajax.core :as ajax]
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.header.navigation :as navigation]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.app.website.cart.minicart :as minicart]
   [ycweb.app.website.cart.model :as minicart.model]))

(rum/defc menu-button < rum/reactive [app-atom]
  [:nav.menu-button-wrapper
   {:aria-hidden "true"}
   [:a.menu-button.js-main-nav-open-button
    {:href "#"
     #_#_:on-click #(swap! app-atom update :nav-open? not)}
    [:i
     {:class (u/bem :icon [:block :default :is-dark :menu])}
     [:span.u-hidden-from-view "Open Main Menu"]]]])

(rum/defc logo < rum/reactive [app-atom]
  (let [app-version (cmn/curact app-atom [:app :version])]
    (cond
      (= app-version "dev")
      [:div.header__logo
       [:a.header__branch-text
        {:href "/index.htm?ref=header-logo"}
        "Dev!"]]

      :else
      [:a.header__logo
       {:href "/index.htm?ref=header-logo"}
       [:i.header-logo__icon
        {:class (u/bem :icon [:block :default :is-dark :yc-logo])}]
       [:span.header-logo__text
        "Y"
        [:span.clip-text "uppie"]
        "c"
        [:span.clip-text "hef"]]])))

(rum/defc solutions < rum/static []
  [:nav.solutions-nav-wrapper
   [:ul.solutions-nav
    [:li.solutions-nav__item
     [:a.solutions-nav__link
      {:href "/index.htm?ref=header-link"}
      "Shop Online"]]
    [:li.solutions-nav__item
     [:a.solutions-nav__link
      {:href "/store-directory.htm?ref=header-link"}
      "Stores"]]
    [:li.solutions-nav__item
     [:a.solutions-nav__link
      {:href "/registry.htm?ref=header-link"}
      "Wedding Registry"]]
    [:li.solutions-nav__item
     [:a.solutions-nav__link
      {:href "/trade.htm?ref=header-link"}
      "Trade"
      [:span.u-hidden-from-view " Program"]]]]])

(rum/defc search < rum/reactive [app-atom]
  [:div.search-button-wrapper
   [:a.search-button
    (urlstate/href-on-click #(grid/dispatch-action app-atom :search/instant-search-popup {}))
    [:i.search-button__icon
     {:class (u/bem :icon [:block :default :is-light :search])}]
    [:span.search-button__text
     [:span.u-hidden-from-view "Open "]
     "Search"
     [:span.u-hidden-from-view " Bar"]]]])

(rum/defc user-account-nav < rum/reactive [app-atom options]
  (let [user (cmn/curact app-atom [:user])
        {:keys [afterloginredirect]} options]
    (cond
      user
      [:li
       {:class (u/bem :user-nav__item [:user])}
       [:a.user-nav__link
        {:href "#"
         :on-click
         #(grid/open-modal app-atom :web.header/account-options-popup
            {:config
             {:title "Account Options"
              :max-width 320}})}
        (cond
          (u/presence (:public-id user))
          [:img.user-nav__link-icon.avatar
           {:src (u/cloudinary (:public-id user) {:q "auto" :w 32 :h 32})
            :alt ""
            :width 32
            :height 32}]

          :else
          [:div {:class (str "missing-avatar missing-avatar--u-bg-oil")}
           [:div.missing-avatar__text [:i.icon.icon--user.icon--is-light.icon--medium-small.icon--block]]])
        [:span.user-nav__link-text
         [:span.u-hidden-from-view "Yuppiechef "]
         "Account"]]]

      :else
      [:li
       {:class (u/bem :user-nav__item [:user])}
       [:a.user-nav__link
        {:href (str "/login.htm" (when afterloginredirect (str "?afterloginredirect=" afterloginredirect)))}
        [:i.user-nav__link-icon
         {:class (u/bem :icon [:block :default :is-light :user])}]
        [:span.user-nav__link-text
         "Log In"
         [:span.u-hidden-from-view " to Your Account"]]]])))

(rum/defc cart
  < rum/reactive
  {:did-mount
   (fn [state]
     ; TODO: remove this hook when don't need to get cart detail from PHP
     ; though this is also used to get current cart state for the mini cart,
     ; so will need to find a way to load this in?
     ;; entry-main already wires up comms for every mount this renders in, so
     ;; calling setup-ajax here only risks a second :web/start request.
     #?(:cljs
        (let [[app-atom _] (:rum/args state)]
          (grid/dispatch-action app-atom :web.header/cart-mini-qty {})))
     state)}
  [app-atom]
  (let [{:keys [qty total] :as summary} (cmn/curact app-atom [:cart-summary])
        new-cart-enabled (cmn/curact app-atom [:features :new-cart])]
    #?(:cljs
       (set! js/addToCartUpdate
         (fn [response]
           (swap! app-atom assoc :cart-summary response))))

    (cond
      new-cart-enabled
      (minicart/minicart app-atom)

      (and qty (> qty 0))
      [:li
       {:id "js-cart-wrapper" :class (u/bem :user-nav__item [:cart])}
       [:a.user-cart.user-nav__link.cart-link.js-mfp-open
        {:href "#"
         :target_class "js-cart-popup"}
        [:i.user-nav__link-icon
         {:class (u/bem :icon [:block :default :is-light :cart])}]
        [:span {:class (u/bem :user-cart__count [:has-items])}
         [:span {:class (u/bem :u-hidden-from-view)} "View items in your Cart: "]
         [:span {:class (u/bem :user-cart__count-text :count)} qty]]]]

      ;; nil or 0 qty: cart icon + an invisible placeholder badge that reserves the
      ;; count's slot, so the header siblings don't shift when the count loads in
      ;; (or when this swaps to the minicart). No "0" shown.
      :else
      [:li
       {:id "js-cart-wrapper" :class (u/bem :user-nav__item [:cart])}
       [:span.user-cart.user-nav__link.cart-link
        [:i.user-nav__link-icon
         {:class (u/bem :icon [:block :default :is-light :cart])}]
        [:span {:class (u/bem :user-cart__count [:no-items])}
         [:span {:class (u/bem :u-hidden-from-view)} "Items in your Cart: "]
         [:span {:class (u/bem :user-cart__count-text :count)} "0"]]]])))

;; The new-cart decision arrives with the SSR state, so go straight to the
;; cart the shopper is actually on rather than asking the server which one
;; it is and only then fetching it.
(defmethod grid/action :web.header/cart-mini-qty [app-atom config _]
  (if (cmn/curact app-atom [:features :new-cart])
    (minicart.model/load-cart-data app-atom)
    (ajax/GET "/cart.htm?action=miniqty"
      {:response-format :json
       :keywords? true
       :handler
       (fn [response]
         (swap! app-atom assoc :cart-summary response))})))

(rum/defc help < rum/reactive [app-atom options]
  (let [{:keys [pagetype]} options]
    [:li
     {:class (u/bem :user-nav__item [:help])}
     [:a.user-nav__link
      {:href "#"
       :on-click
       #(grid/open-modal app-atom :web.header/need-help-popup
          {:config
           {:title "Need help?"
            :max-width 320
            :pagetype pagetype}})}
      [:i.user-nav__link-icon
       {:class (u/bem :icon [:block :default :is-light :help])}]
      [:span.user-nav__link-text "Need Help?"]]]))

;; Main Header Component
(rum/defc main-header < rum/reactive [app-atom options]
  [:div.header
   (menu-button app-atom)
   (logo app-atom)
   (solutions)
   ;; TODO: Hide search for certain pages !$hidemainsearch && $pagetype!="school" && $pagetype!="forum" && (($page.name!="order_placed"))
   (when (not (:hidesearch options))
     (search app-atom))
   [:ul.user-nav
    (user-account-nav app-atom options)
    (cart app-atom)
    (when-not (= (:pagetype options) :help)
      (help app-atom options))]])

;=================================================================================================
;=========================================== MODALS ==============================================
;=================================================================================================
;; Account Options Modal
;; TODO: this modal is too wide. check the live version of this to see the intended size.
(rum/defc account-options-body < rum/reactive [app-atom]
  (let [user (cmn/curact app-atom [:user])
        registry-order-id (cmn/curact app-atom [:registry/order-id])]
    [:div.modal__content
     (headings/heading "Account" {:type :h2 :size :small})

     [:div.button-group.u-block-center
      (when (:supplier-user? user)
        [:div.u-margin-bottom-10
         [:a
          {:href "/supplier-dashboard.htm"
           :class
           (u/bem :button [:bordered :secondary :full :default :raised])}
          [:span.button__text "Supplier Dashboard"]]])
      ;; Served only to the development team; the bundle knows no path
      (when-let [{:keys [href text]} (:dev-tools user)]
        [:div.u-margin-bottom-10
         [:a
          {:href href
           :class
           (u/bem :button [:bordered :secondary :full :default :raised])}
          [:span.button__text text]]])
      (when registry-order-id
        [:div.u-margin-bottom-10
         [:a
          {:href (str "/registry.htm?action=edit&orderid=" registry-order-id)
           :class
           (u/bem :button [:bordered :secondary :full :default :raised])}
          [:span.button__text "Manage Registry"]]])
      [:div.u-margin-bottom-10
       [:a
        {:href "/myaccount.htm?action=track"
         :class
         (u/bem :button [:bordered :secondary :full :default :raised])}
        [:span.button__text "Manage Orders"]]]
      [:div.u-margin-bottom-10
       [:a
        {:href "/myaccount.htm"
         :class
         (u/bem :button [:bordered :secondary :full :default :raised])}
        [:span.button__text "Account Dashboard"]]]
      [:div.u-margin-bottom-10
       [:a
        {:href "/myaccount.htm?action=wishlist"
         :class
         (u/bem :button [:bordered :secondary :full :default :raised])}
        [:span.button__text "Wish List"]]]
      [:div.u-margin-bottom-30
       [:a
        {:href "/myaccount.htm?action=accountsettings"
         :class
         (u/bem :button [:bordered :secondary :full :default :raised])}
        [:span.button__text "Account Settings"]]]
      [:a
       {:href "/login.htm?action=logoff"
        :class
        (u/bem :button [:bordered :secondary :full :default :raised])}
       [:span.button__text "Log Out"]]]]))

(defmethod grid/modal-config :web.header/account-options-popup [_ _ _]
  {:body-raw account-options-body
   :modal-type :variable})

(rum/defc need-help-body < rum/reactive [_ modal-atom _]
  (let [config (cmn/curact modal-atom [:config])]
    [[:div.modal__header
      (headings/heading (:title config)
        {:type :h2 :size :default :flush true :class "modal__heading"})]
     [:div.modal__content
      [:div.button-group.u-block-center
       [:div.u-margin-bottom-10
        (buttons/button-web "Online Help Centre"
          {:href
           (if (= (:pagetype config) :registry)
             "/help.htm?action=category&id=7&name=Registries&ref=header-link"
             "/help.htm?&ref=header-link")
           :style :secondary
           :size :default
           :icon :help
           :full true})]
       [:div.u-margin-bottom-10
        (buttons/button-web "Open live chat"
          {:href "/chat.htm"
           :style :secondary
           :size :default
           :icon :chat
           :full true})]
       [:div.u-margin-bottom-10
        (buttons/button-web "Contact us"
          {:href "/help.htm#help-contact-section"
           :style :secondary
           :size :default
           :icon :email
           :full true})]]]]))

(defmethod grid/modal-config :web.header/need-help-popup [_ _ _]
  {:body-raw need-help-body
   :modal-type :variable})
;=================================================================================================
;=================================================================================================

(rum/defc user-nav < rum/reactive [app-atom options]
  (let [user (cmn/curact app-atom [:user])
        {:keys [afterloginredirect]} options
        user-details
        {:user/avatar-letter (:avatarletter user)
         :user/avatar-colour (:avatarcolour user)
         :user/public-id (:public-id user)}]
    [:div.main-nav-user
     [:div.main-nav-user__account
      [:figure.main-nav-user__image-wrapper
       (web-common/user-avatar user-details)]
      [:div.main-nav-user__button-wrapper
       (cond
         user
         [:a
          {:href "#"
           :on-click
           #(grid/open-modal app-atom :web.header/account-options-popup
              {:config
               {:title "Account Options"
                :max-width 320}})
           :class
           (u/bem :button [:bordered :secondary :full :small :raised])}
          [:span.button__text
           [:span.u-hidden-from-view "View and Manage Your "]
           "Account"]]

         :else
         (buttons/button-web "Log in"
           {:href
            (str "/login.htm" (when afterloginredirect (str "?afterloginredirect=" afterloginredirect)))
            :style :light
            :size :small}))]]

     (when user
       [:div.main-nav-user__details
        [:h1.main-nav-user__name (u/glue " " (:firstname user) (:lastname user))]
        [:p.main-nav-user__email (:email user)]])

     [:a.main-nav__close-button.js-main-nav-close-button
      {:href "#"
       #_#_:on-click #(swap! app-atom update :nav-open? not) :aria-hidden "true"}
      [:i
       {:class (u/bem :icon [:block :default :is-light :close])}
       [:span.u-hidden-from-view "Close Main Menu"]]]]))

(defn nav-options-festive []
  [:ul.main-nav-solutions.u-bg-greenery
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link.u-text-white
     {:href "/festive-shop.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:span {:class (u/bem :icon [:block :default :is-light])}
       "🎁"]]
     [:span.main-nav-solutions__text "Festive Shop"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options-back-to-school []
  [:ul.main-nav-solutions.u-bg-niagara
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link.u-text-white
     {:href "/back-to-school.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:span {:class (u/bem :icon [:block :default :is-light])}
       "🍎"]]
     [:span.main-nav-solutions__text "Back to Routine"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options-valentines-day []
  [:ul.main-nav-solutions.u-bg-terracotta
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link.u-text-white
     {:href "/valentines-day.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :gift])}]]
     [:span.main-nav-solutions__text "Valentine's Ideas"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options-mothers-day []
  [:ul.main-nav-solutions.u-bg-iris
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link.u-text-white
     {:href "/mothers-day-gift-guide.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:span {:class (u/bem :icon [:block :default :is-light])}
       "🎁"]]
     [:span.main-nav-solutions__text "Mother's Day"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options-fathers-day []
  [:ul.main-nav-solutions.u-bg-niagara
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link.u-text-white
     {:href "/fathers-day-gift-guide.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :gift])}]]
     [:span.main-nav-solutions__text "Father's Day"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options-birthday-sale []
  [:ul.main-nav-solutions.u-bg-flamingo
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link.u-text-white
     {:href "/our-20th-birthday-sale.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :gift])}]]
     [:span.main-nav-solutions__text "🪩 20th Birthday SALE"]
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-light :arrow-right])}]]]]])

(defn nav-options [app-atom options]
  [:ul.main-nav-solutions
   [:li
    {:class (u/bem :main-nav-solutions__item [:help])}
    [:a.main-nav-solutions__link
     {:href "#"
      :on-click
      #(grid/open-modal app-atom :web.header/need-help-popup
         {:config
          {:title "Need help?"
           :max-width 320
           :pagetype (:pagetype options)}})}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :help])}]]
     [:span.main-nav-solutions__text "Need Help?"]]]])

(defn nav-solutions []
  [:ul.main-nav-solutions
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link
     {:href "/index.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :cart])}]]
     [:span.main-nav-solutions__text "Shop Online"]]]
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link
     {:href "/store-directory.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :location])}]]
     [:span.main-nav-solutions__text "Store Locator"]]]
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link
     {:href "/registry.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :ring])}]]
     [:span.main-nav-solutions__text "Wedding Registry"]]]
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link
     {:href "/trade.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :trade])}]]
     [:span.main-nav-solutions__text "Trade"]]]
   [:li.main-nav-solutions__item
    [:a.main-nav-solutions__link
     {:href "/chat.htm?ref=header-link"}
     [:span.main-nav-solutions__icon
      [:i {:class (u/bem :icon [:block :default :is-dark :chat])}]]
     [:span.main-nav-solutions__text "Live chat"]]]])

;; Outputs
(rum/defc impersonation-feedback < rum/reactive [app-atom]
  (let [impersonating? (cmn/curact app-atom [:impersonating?])]
    (when impersonating?
      [:div.feedback.feedback--full.feedback--flush.feedback--warning.feedback--impersonating.ie-group
       [:div.feedback__icon
        [:i.icon.icon--warning.icon--is-dark.icon--default.icon--inline]]
       [:div.feedback__message
        [:h4.feedback-title "Customer Impersonation Mode"]
        [:p.feedback-description
         "You're impersonating a customer. Return to "
         [:a
          {:href "/login.htm?action=returntoadmin"}
          "Yuppiechef Admin Dashboard."]]]])))

(rum/defc cookies-disabled-feedback < rum/reactive [app-atom]
  [:div.feedback.feedback--full.feedback--flush.feedback--header.feedback--info.ie-group
   [:div.feedback__icon [:i.icon.icon--inline.icon--info]]
   [:div.feedback__message
    [:h4.feedback-title
     "It looks like cookies are turned off in your browser. Most of this site will not work as expected. "
     [:a.text-link.text-link--muted
      {:href
       "https://www.yuppiechef.com/help.htm?action=article&id=69&name=What-are-browser-cookies-and-why-do-I-need-them&ref=usermessage"}
      "Read about how to fix it."]]]])

(defn test-cookies-enabled []
  #?(:cljs
     (cond
       (. js/navigator -cookieEnabled)
       true

       :else
       (do
         (set! (. js/document -cookie) "cookietest=1")
         (let [test-cookie (. (. js/document -cookie) indexOf "cookietest=")
               cookie-present? (and test-cookie (not= test-cookie -1))]
           (set! (. js/document -cookie) "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT")
           cookie-present?)))))

(rum/defc header < rum/reactive [app-atom options]
  (let [app-version (cmn/curact app-atom [:app :version])
        user (cmn/curact app-atom [:user])
        cookies-disabled? (cmn/curact app-atom [:cookies-disabled?])
        nav-open? (cmn/curact app-atom [:nav-open?])
        impersonating? (cmn/curact app-atom [:impersonating?])
        time-based-campaigns (cmn/curact app-atom [:time-based-campaigns])
        {:keys [pagetype]} options]
    #?(:cljs
       (let [cookie-enabled? (test-cookies-enabled)]
         (when (not cookie-enabled?)
           (swap! app-atom assoc :cookies-disabled? true))))
    [:<>
     [:header
      {:class (u/bem :header-wrapper [(when (and impersonating? (contains? (:permissions user) "SiteAdmin")) :is-relative) (when (= app-version "dev") :is-dev)])}
      (when cookies-disabled?
        (cookies-disabled-feedback app-atom))
      (impersonation-feedback app-atom)
      (buttons/button-web "Skip to main content"
        {:href "#main-content"
         :style :secondary
         :size :default
         :class :skip-button})
      (main-header app-atom options)
      [:div.js-main-nav-overlay {:class (u/bem :main-nav-overlay [(when nav-open? :is-open)])}]]
     [:nav.js-main-nav {:role "navigation" :class (u/bem :main-nav [(when user :logged-in) (when nav-open? :is-open)])}
      (user-nav app-atom options)
      [:div.main-nav__menu-wrapper
       (when (:festive-header time-based-campaigns)
         (nav-options-festive))
       (when (:back-to-school time-based-campaigns)
         (nav-options-back-to-school))
       (when (:valentines-day time-based-campaigns)
         (nav-options-valentines-day))
       (when (:mothers-day time-based-campaigns)
         (nav-options-mothers-day))
       (when (:fathers-day time-based-campaigns)
         (nav-options-fathers-day))
       (when (:our-birthday-sale time-based-campaigns)
         (nav-options-birthday-sale))
       (nav-options app-atom options)
       (cond
         (= pagetype :forum)
         (navigation/forum-navigation app-atom)

         (= pagetype :school)
         (navigation/school-navigation app-atom user)

          ;TODO: This needs more work around user permissions - supplier dashboard is not part of this port
          ;(= pagetype :supplier)
          ;(navigation/supplier-navigation)

         (= pagetype :registry)
         (navigation/registry-navigation app-atom user)

         :else
         (navigation/shop-menu app-atom options))
       (nav-solutions)]]]))

(defmethod flow/render-screen :web.header [app-atom _]
  (header app-atom {}))
